export default __webpack_public_path__ + "static/media/profileWoman.fd67dc3b.svg";